module.exports = __webpack_public_path__ + "assets/img/67_316_2.89030b28.jpg";